import { render, staticRenderFns } from "./PlanFrame.vue?vue&type=template&id=87fb7a68&scoped=true&"
import script from "./PlanFrame.vue?vue&type=script&lang=js&"
export * from "./PlanFrame.vue?vue&type=script&lang=js&"
import style0 from "./PlanFrame.vue?vue&type=style&index=0&id=87fb7a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fb7a68",
  null
  
)

export default component.exports